/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";

import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import FileUploadProgress from "react-fileupload-progress";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  toggleDocModal,
  updateDoc,
  orderApprove
} from "../../store/orders/ordersAction";
import { toggleAlert } from "../../store/alertbox/alertboxAction";
import { config, msg } from "../../constants";
import { globalConstants } from "../../global-configs";

class OrderModal extends Component {
  constructor(props) {
    super(props);
    // console.log('modalDoc------------------------', props);
    const docSets = (typeof props.order.doc_structures === 'undefined' || props.order.doc_structures === null || props.order.doc_structures === '') ? [] : JSON.parse(props.order.doc_structures);
    // console.log(docSets);
    this.state = {
      mainDocId: [1, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
      previewModal: false,
      previewUrl: null,
      pdfModal: false,
      acceptTerm: false,
      acceptTermInput: false,
      cssSpinner: '',
      cssSpinnerSubmit: '',
      thePdfId: '',
      pdfBlob: null,
      rawBlob: null,
      getFile: false,
      docSets: docSets,
      order: props.order,
      idx: props.idx,
      updatedoc: props.updatedoc,
      maxMB: globalConstants.IMPORT_DOCUMENT,
      alertModal: false,
      alertMsg: '',
    };
  };

  componentWillMount() {
    this.setState({
      cssSpinner: 'hide',
      cssSpinnerSubmit: 'hide'
    })
  }

  componentWillReceiveProps(next) {
    const docSets = (typeof next.order.doc_structures === 'undefined' || next.order.doc_structures === null || next.order.doc_structures === '') ? [] : JSON.parse(next.order.doc_structures);
    this.setState({
      order: next.order,
      docSets: docSets,
      idx: next.idx,
      updatedoc: next.updatedoc,
      alertModal: false,
      alertMsg: '',
    });
  }

  toggleTermInput = () => {
    this.setState(prevState => ({
      acceptTermInput: !prevState.acceptTermInput
    }));
  };


  togglePDFModal = async () => {
    var chkError = false
    this.setState({
      cssSpinner: ''
    })

    let thePdfUrl = `${config.generateUrlNew}/${this.state.order.project_id}/${this.state.order.order_id}`

    let thePdfId = 0;

    const docLoop = this.state.docSets.map(val => {
      if (this.state.mainDocId.indexOf(parseInt(val.id)) !== -1) {
        thePdfId = parseInt(val.id)
      }
    })

    console.log('this.state.mainDocId', this.state.mainDocId);
    console.log('this.state.docSets', this.state.docSets);

    switch (thePdfId) {
      case 1:
      case 8:
      case 9:
      case 10:
        thePdfUrl = `${config.generateUrlNew}/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 11:
        thePdfUrl = `${config.generateUrlNew}/payroll/postpaid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 12:
        thePdfUrl = `${config.generateUrlNew}/payroll/hybrid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 13:
        thePdfUrl = `${config.generateUrlNew}/simonly/postpaid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 14:
        thePdfUrl = `${config.generateUrlNew}/simonly/hybrid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 15:
        thePdfUrl = `${config.generateUrlNew}/onetime/postpaid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 16:
        thePdfUrl = `${config.generateUrlNew}/onetime/hybrid/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 17:
        thePdfUrl = `${config.generateUrlNew}/payroll/postpaid2/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      case 18:
        thePdfUrl = `${config.generateUrlNew}/payroll/hybrid2/${this.state.order.project_id}/${this.state.order.order_id}`
        break
      default:

    }

    console.log('thePdfId', thePdfId)
    console.log('thePdfUrl', thePdfUrl)


    await fetch(thePdfUrl,
      {
        // method: "GET",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ customer_id: this.state.order.customer_id })
      }
    ).then(res => res.blob()
    ).then(blob => {
      const objectURL = URL.createObjectURL(blob);
      this.setState({
        thePdfId: thePdfId,
        pdfBlob: objectURL,
        rawBlob: blob
      });
    }).catch(error => {
      chkError = true
      console.log(error);
      // this.props.toggleAlert(`ขออภัย ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาลองใหม่ในภายหลัง`);
      this.openAlertModal('ขออภัย ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาลองใหม่ในภายหลัง');
    });
    this.setState({
      cssSpinner: 'hide'
    })
    if (!chkError) {
      this.setState(prevState => ({
        pdfModal: !prevState.pdfModal
      }));

      if (!this.state.pdfModal) {
        setTimeout(() => {
          if (document.getElementById("idPDFModal")) {
            document
              .getElementById("idPDFModal")
              .parentElement.classList.add("modal-full");
          }
        }, 400);
      }

    }
  };

  togglePreviewModal = async () => {
    const thisComp = this;
    thisComp.setState({
      previewModal: !thisComp.state.previewModal
    });
  };

  uploadBlobFile = () => {
    console.log('uploadBlobFile--------');
    document.getElementById('finalBtn').style.display = "none"
    this.setState({
      cssSpinnerSubmit: ''
    })
    var fd = new FormData();
    fd.append("file", this.state.rawBlob, this.state.order.order_id + ".pdf");
    const docSets = this.state.docSets;
    this.state.order.document_all.forEach(val => {
      // if (val.doc_type_id === 1 || val.doc_type_id === 8) {

      console.log('val.doc_type_id', val.doc_type_id)
      if (this.state.mainDocId.indexOf(parseInt(this.state.thePdfId)) !== -1 && parseInt(val.doc_type_id) === parseInt(this.state.thePdfId)) {
        console.log('this.state.thePdfId', this.state.thePdfId)
        const docSetFound = docSets.filter(v => (v.id === this.state.thePdfId));
        const docCode = (docSetFound.length > 0) ? docSetFound[0].code : '';
        const docId = (docSetFound.length > 0) ? docSetFound[0].id : '';
        console.log('docSetFound', docSetFound)

        const uploadUrlFull = `${config.uploadFileUrl}/project/doc/upload/bycode/${docCode}/${val.cdc_filetype_code}/${this.state.order.order_id}/${this.state.order.customer_id_card}`

        console.log('uploadUrlFull', uploadUrlFull)

        fetch(
          uploadUrlFull,
          {
            method: "POST",
            headers: {
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + localStorage.getItem("access_token")
            },
            body: fd
          }
        ).then(res => res.json()).then(data => {
          val.value = this.state.order.order_id + ".pdf";
          val.key_id = data.file_id;
          var param = {
            ...val,
            code: docCode,
            doc_type_id: docId,
            doc_id: this.state.order.doc_id,
            order_id: this.state.order.order_id,
            value: this.state.order.order_id + ".pdf",
            key_id: data.file_id,
            file_id: data.file_id,
            doc_code: data.doc_code,
            project_id: this.state.order.project_id,
            customer_id: this.state.order.customer_id
          };
          // this.props.updateDoc(param);

          var url = `${config.uploadFileUrl}/document/${this.state.order.order_id}`;
          // console.log('----------------End -------------------------');
          this.updateDoc(url, param);
          this.setState({
            cssSpinnerSubmit: '',
            thePdfId: 0
          })
          this.setState(prevState => ({
            pdfModal: !prevState.pdfModal
          }));
        });
      }
    });
  };

  onCloseModal = () => {
    this.setState({
      acceptTerm: false,
      acceptTermInput: false
    });
    this.props.toggleDocModal({});
  };

  onCancelModal = () => {
    this.onCloseModal();
    window.location.reload()
  };

  getterForm = id => {
    return new FormData(document.getElementById(`form_${id}`));
  };

  addToken = xhr => {
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("access_token"));
    return xhr;
  };

  progressBar = (index, progress, hasError, cancelHandler) => {
    const thisComp = this;
    // console.log('progressBar-----', hasError, progress, thisComp.state.uploadErrorText);
    if (hasError || progress > -1) {
      let barStyle = {};
      barStyle.width = progress + "%";

      let message = "";
      if (hasError) {
        barStyle.backgroundColor = "#d9534f";
        message = (<span style={{ color: "#a94442" }}>Failed to upload</span>);
      }

      return (hasError) ? null : (
        <div id="uploadFormSection">
          <div className="progressWrapper">
            {!hasError ?
              <Spinner
                size="sm"
                color="danger"
                id={'cssSpinner' + index} />
              : ''}
          </div>
          <button className="cancelButton" onClick={cancelHandler}>
            <span>&times;</span>
          </button>
          {message ? <div style={{ clear: "left" }}>{message}</div> : ""}
          <div className="row" style={{ marginBottom: "28px" }} />
        </div>
      );
    } else {
      return null;
    }
  };

  onSubmitFile = (responseText, name, index) => {
    document.getElementById('cssSpinner' + index).style.display = 'none';
    document.getElementById('uploadFormSection').style.display = 'none';

    const thisComp = this;

    const response = JSON.parse(responseText);

    const docSets = thisComp.state.docSets;
    if (parseInt(response.code) === 200) {
      docSets.forEach(val => {
        // console.log(val.code);
        if (val.code === response.doc_code) {
          console.log(val.code + '===' + response.doc_code);

          val.file_id = response.file_id;
          var fileName = response.file_name;

          var sendingData = {
            ...val,
            doc_type_id: val.id,
            doc_id: thisComp.state.order.doc_id,
            key_id: response.file_id,
            file_id: response.file_id,
            value: fileName,
            doc_code: response.doc_code,
            project_id: thisComp.state.order.project_id,
            customer_id: thisComp.state.order.customer_id,
            order_id: thisComp.state.order.order_id
          };

          var url = `${config.uploadFileUrl}/document/${thisComp.state.order.order_id}`;
          // console.log('----------------End -------------------------');
          thisComp.updateDoc(url, sendingData);
        }
      });

    } else {
      thisComp.openAlertModal('Upload Document Error : '+response.description);
    }
  };

  updateDoc = async (url, params) => {
    // console.log('updateDoc-----');
    const thisComp = this;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(params);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const resp = await fetch(url, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result);
        // console.log('idx >> ', thisComp.state.idx);
        if (parseInt(result.code) === 200) {
          thisComp.state.updatedoc(thisComp.state.idx, result.data);
        } else {
          thisComp.openAlertModal('Update Document Error');
        }

        return result
      })
      .catch(error => console.log(error));

    return resp;
  };

  onChangeFile = (e, val, onSubmit) => {
    const thisComp = this;

    const fileName = e.target.value.substring(
      e.target.value.lastIndexOf("\\") + 1,
      e.target.value.length
    );

    // const doc_type_id = val.doc_type_id;
    // console.log('onChangeFile-----', fileName);
    if (e.target.value) {
      // console.log('onSubmit', e);
      onSubmit(e);
    }

  };

  finalBtn = () => {
    const thisComp = this;
    // console.log(thisComp.state.order);
    // console.log(thisComp.state.docSets);
    const documentItems = thisComp.state.order.document_items.filter(d => (d.order_id === thisComp.state.order.order_id));
    const docReq = thisComp.state.docSets.filter(val => {
      const docFound = documentItems.filter(d => (d.doc_type_id === val.id && d.doc_code === val.code));
      return (docFound.length === 0 && val.req);
    });

    // console.log(docReq);
    if (docReq.length > 0) {
      thisComp.openAlertModal('กรุณาอัพโหลดเอกสารให้ครบถ้วน');
    } else {
      // console.log('Close Modal--');
      this.onCloseModal(this.state.order);

      // console.log('Open Modal 01');
      orderApprove(this.state.order);

      // console.log('Open Modal 00');
      this.props.toggleAlert(msg.docOrderApprove, "1");
      // this.openAlertModal(msg.docOrderApprove);

    }
  };

  customForm = (onSubmit, val, i) => {
    const thisComp = this;
    const documentItems = thisComp.state.order.document_items.filter(d => (d.order_id === thisComp.state.order.order_id));
    const docFound = documentItems.filter(d => (d.doc_type_id === val.id && d.doc_code === val.code));
    return (
      <form id={`form_${i}`}>
        <div className="row" style={{ marginTop: "-1px" }}>
          <div className="col-12 col-md-4">
            <p className="upfile-name">
              {val.label}{' '}{(val.req) ? (<span class="badge rounded-pill bg-danger text-white">Req</span>) : (null)}
            </p>
          </div>
          <div className="col-12 col-md-5">
            <p className="docfile-name">{(docFound.length > 0) ? <a
              data-toggle="modal"
              href="#/"
              // onClick={() => thisComp.onLoadDocument(val)}
              onClick={() => {
                thisComp.previewFile(docFound[0]);
              }}
            >{docFound[0].file_name}</a> : ''}</p>
          </div>
          <div className="col-12 col-md-3">
            <div className="custom-file" typeid={val.id}>
              <input
                id={val.code}
                type="file"
                name="file"
                style={{ display: "none" }}
                // disabled={(val.id===1 || val.id===8) || (docFound.length > 0 && (docFound[0].doc_type_id === 1 || docFound[0].doc_type_id === 8))}
                disabled={(this.state.mainDocId.indexOf(parseInt(val.id)) !== -1 || (docFound.length > 0 && this.state.mainDocId.indexOf(parseInt(docFound[0].doc_type_id)) !== -1))}
                accept="image/png, image/jpeg, application/pdf, application/msword, .doc, .docx"
                onChange={e => {
                  if (e.target.value !== '') {
                    if (e.target.files[0].size > (thisComp.state.maxMB * 1024 * 1024)) {
                      thisComp.openAlertModal("กรุณาตรวจสอบประเภทไฟล์ข้อมูลและขนาดต้องไม่เกิน " + thisComp.state.maxMB + " MB.");
                    } else {
                      thisComp.onChangeFile(e, val, onSubmit);
                    }
                  }
                }}
              />
              {(this.state.mainDocId.indexOf(parseInt(val.id)) !== -1 || (docFound.length > 0 && this.state.mainDocId.indexOf(parseInt(docFound[0].doc_type_id)) !== -1)) ? (
                // <label
                //   className="custom-file-label browseText disabled"
                //   htmlFor={val.code}
                // >
                //   <a
                //     href={thisComp.state.pdfBlob}
                //     download={thisComp.state.order.order_id + ".pdf"}
                //   >
                //     <p className="namePdf">{val.label}</p>
                //   </a>
                // </label>
                <></>
              ) : (
                <label
                  className="custom-file-label browseText"
                  htmlFor={val.code}
                >
                  <p className="namePdf">{val.label}</p>
                </label>
              )}
              <div className="pipeBrowseFile" />
            </div>
          </div>
        </div>
      </form>
    );
  };

  getFILE = async (file_id) => {
    await fetch(`${config.uploadFileUrl}/getfile/${file_id}`,
      {
        // method: "GET",
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },
      })
      .then(res => res.blob())
      .then(blob => {
        const objectURL = URL.createObjectURL(blob);
        this.setState({
          pdfBlob: objectURL,
          rawBlob: blob,
          getFile: true
        });
      });
  }

  getFileNew = async (file_type, file_id) => {
    var objectURL = `${config.uploadFileUrl}/project/doc/write/${file_type}/${file_id}`;

    this.setState({
      pdfBlob: objectURL,
      getFile: true
    });
  }

  previewFile = async (val) => {
    // console.log(val);
    const thisComp = this;
    const file_id = val.file_id;
    const file_type = val.file_name.split(".")[1] ? val.file_name.split(".")[1] : "txt";
    var objectURL = `${config.uploadFileUrl}/project/doc/write/${file_type}/${file_id}`;

    thisComp.setState({
      previewUrl: objectURL,
      previewModal: !thisComp.state.previewModal
    }, () => {
      // document.getElementById("idPreviewModal").parentElement.classList.add("modal-full");
    });
  }

  previewStartFile = async (val) => {
    const thisComp = this;
    const file_id = val.file_id;
    const file_type = val.value.split(".")[1] ? val.value.split(".")[1] : "txt";
    var objectURL = `${config.uploadFileUrl}/project/doc/write/${file_type}/${file_id}`;

    thisComp.setState({
      previewUrl: objectURL,
      previewModal: !thisComp.state.previewModal,
      getFile: true
    }, () => {
      // document.getElementById("idPreviewModal").parentElement.classList.add("modal-full");
    });
  }

  toggleAlertModal = () => {
    // console.log('togglePDFModal-----');
    this.setState({
      alertModal: !this.state.alertModal
    });
  };

  openAlertModal = msg => {
    console.log(msg);
    this.setState({
      alertModal: true,
      alertMsg: msg
    });
  };

  render() {
    const thisComp = this;
    // console.log('render>>', thisComp.state.docSets);
    if (thisComp.state.order.document_detail && thisComp.state.order.document_detail[0]) {
      if (thisComp.state.order.document_detail[0].file_id && !thisComp.state.getFile) {
        thisComp.previewStartFile(thisComp.state.order.document_detail[0]);
      }
    } else {
      thisComp.state.order.document_detail = []
    }
    const closeBtn = <button className="close" onClick={thisComp.onCloseModal}>&times;</button>;

    const docSets = thisComp.state.docSets;
    return (
      <>
        <Modal
          size="lg"
          isOpen={thisComp.props.isDocModalOpen}
          toggle={thisComp.onCloseModal}
          scrollable={true}
          autoFocus={true}
        >
          <ModalHeader toggle={thisComp.toggle} close={closeBtn}>ยืนยันการสั่งซื้อ</ModalHeader>
          <ModalBody>
            <h4 className="modal-ttl">อัพโหลดเอกสาร </h4>
            <div className="box-upfile" style={{ padding: "1rem" }}>
              {
                docSets.map((val, i) => {
                  const docFound = thisComp.state.order.document_all.filter(d => (d.doc_type_id === val.id));
                  const cdcFiletypeCode = (docFound.length > 0) ? docFound[0].cdc_filetype_code : '';
                  return (
                    <FileUploadProgress
                      disabled={i === 0}
                      key={i}
                      method="post"
                      url={`${config.uploadFileUrl}/project/doc/upload/bycode/${val.code}/${cdcFiletypeCode}/${thisComp.state.order.order_id
                        }/${thisComp.state.order.customer_id_card}`}
                      onLoad={(e, request) => { thisComp.onSubmitFile(request.response, val.name, i); }}
                      onError={(e, request) => {
                        const requestResponse = JSON.parse(request.response);
                        const errorMessage = requestResponse.description || '';
                        thisComp.openAlertModal('Upload File failed (' + errorMessage + ')');
                        console.log("error", e, request);
                      }}
                      formGetter={() => { return thisComp.getterForm(i); }}
                      formRenderer={onSubmit => { return thisComp.customForm(onSubmit, val, i); }}
                      progressRenderer={thisComp.progressBar.bind(thisComp, i)}
                      beforeSend={thisComp.addToken}
                    />
                  )
                })}
            </div>
            <p className="text-note">
              แนบเอกสาร (ไฟล์ประเภท PDF, JPG, PNG, DOC, DOCX) ขนาดไม่เกิน {thisComp.state.maxMB} MB. เท่านั้น
            </p>
            {thisComp.state.acceptTermInput ? (
              ""
            ) : (
              <div className="text-center">
                <Spinner color="danger" className={thisComp.state.cssSpinner} />
                <button
                  className="btn btn-primary btn-sm btn-modalCondition"
                  onClick={thisComp.togglePDFModal}
                >
                  อ่านยอมรับเงื่อนไขและสัญญาการรับสิทธิ{" "}
                </button>
              </div>
            )}
            {thisComp.state.acceptTermInput ? (
              <div className="condition-checked" style={{ display: "block" }}>
                <div className="condition-dl">
                  <label className="label--checkbox">
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={thisComp.state.acceptTermInput}
                      onChange={thisComp.toggleTermInput}
                      disabled
                    />
                  </label>
                  <span>&nbsp;ข้าพเจ้ายอมรับเงื่อนไขและสัญญา</span>
                </div>
                <p className="text-checked">
                  ทางบริษัทฯ ขอสงวนสิทธิในการเปลี่ยนแปลงการสั่งจองสินค้า{" "}
                  <br />
                  ควรตรวจสอบข้อมูลให้เรียบร้อยก่อนกดยืนยันสั่งซื้อ
                </p>
              </div>
            ) : (
              ""
            )}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-cc btn-sm"
              data-dismiss="modal"
              onClick={thisComp.onCancelModal}
            >
              ยกเลิก
            </button>
            <button
              type="button"
              className="btn btn-cf btn-sm"
              disabled={thisComp.state.acceptTermInput ? false : true}
              onClick={thisComp.finalBtn}
            >
              ยืนยันการสั่งซื้อ
            </button>
          </ModalFooter>
        </Modal>

        <Modal
          // className="modal-full"
          id="idPDFModal"
          isOpen={thisComp.state.pdfModal}
          toggle={thisComp.togglePDFModal}
          scrollable={true}
        >
          <ModalBody>
            <div className="show-pdf">
              <object id="ContainerElementID" width="100%" data={thisComp.state.pdfBlob} type="application/pdf" />
            </div>
            <div className="condition-checkbox">
              <label className="label--checkbox">
                <input
                  type="checkbox"
                  className="checkbox"
                  name="acceptTermInput"
                  checked={thisComp.state.acceptTermInput}
                  onChange={thisComp.toggleTermInput}
                />
                &nbsp;ข้าพเจ้ายอมรับเงื่อนไขและสัญญา
              </label>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-cc btn-sm"
              onClick={thisComp.togglePDFModal}>
              ยกเลิก
            </button>
            <button
              id="finalBtn"
              type="button"
              className="btn btn-cf btn-sm"
              disabled={!thisComp.state.acceptTermInput}
              onClick={thisComp.uploadBlobFile}>
              ตกลง
            </button>
            <Spinner color="danger" className={thisComp.state.cssSpinnerSubmit} />
          </ModalFooter>
        </Modal>


        <Modal
          id="idPreviewModal"
          isOpen={thisComp.state.previewModal}
          toggle={thisComp.togglePreviewModal}
          dialogClassName="custom-pv-modal"
          bsclassName="pv-modal"
          fullscreen={true}
        >
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
              onClick={thisComp.togglePreviewModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="show-pdf" style={{ minWidth: '100%' }} >
              <embed src={thisComp.state.previewUrl} style={{ minWidth: '100%', minHeight: '800px' }} />
            </div>
          </div>
          <div className="modal-footer" style={{ backgroundColor: "white" }}>
            <button
              type="button"
              className="btn btn-cf btn-sm"
              onClick={thisComp.togglePreviewModal}
            >
              ปิด
            </button>
          </div>
        </Modal>

        <Modal
          id="uiAlert"
          isOpen={this.state.alertModal}
          toggle={this.toggleAlertModal}
        >
          <div className="modal-body">{this.state.alertMsg}</div>
          <div className="modal-footer text-center" style={{ backgroundColor: "white" }}>
            <button
              type="button"
              className="btn btn-cf btn-sm"
              onClick={this.toggleAlertModal}
            >
              ปิด
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

OrderModal.propTypes = {
  isDocModalOpen: PropTypes.bool.isRequired,
  toggleDocModal: PropTypes.func.isRequired,
  toggleAlert: PropTypes.func.isRequired,
  updateDoc: PropTypes.func.isRequired,
  orderApprove: PropTypes.func.isRequired,
  order: PropTypes.object
};

const mapStateToProps = state => ({
  isDocModalOpen: state.orders.isDocModalOpen,
  order: state.orders.order
});

export default connect(
  mapStateToProps,
  {
    toggleDocModal,
    updateDoc,
    orderApprove,
    toggleAlert
  }
)(OrderModal);
